// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"297":"7ced5a66","643":"ab8ebd5a","787":"488448e3"}[chunkId] + ".chunk.js";
};